interface IGetShouldBlurNsfwAvatarsProps {
  isNsfwUserToggleAllowed: boolean;
  blurNSFW: boolean;
}

export default function getShouldBlurNsfwAvatars({ isNsfwUserToggleAllowed, blurNSFW }: IGetShouldBlurNsfwAvatarsProps): boolean {
  return !isNsfwUserToggleAllowed || blurNSFW;
}
